/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./Factory"], function (require, exports, Factory_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ActionCreatorBase = /** @class */ (function (_super) {
        __extends(ActionCreatorBase, _super);
        function ActionCreatorBase() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return ActionCreatorBase;
    }(Factory_1.Initializable));
    exports.ActionCreatorBase = ActionCreatorBase;
    var ActionsHubBase = /** @class */ (function (_super) {
        __extends(ActionsHubBase, _super);
        function ActionsHubBase() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return ActionsHubBase;
    }(Factory_1.Initializable));
    exports.ActionsHubBase = ActionsHubBase;
    var Action = /** @class */ (function () {
        function Action() {
            this.listeners = [];
        }
        Action.prototype.invoke = function (payload) {
            if (Action.executing) {
                throw new Error("Cannot invoke an action from inside another action.");
            }
            Action.executing = true;
            try {
                this.listeners.forEach(function (listener) {
                    listener(payload);
                });
            }
            finally {
                Action.executing = false;
            }
        };
        /**
         * Add listener to the action
         * @param listener Listener to add
         */
        Action.prototype.addListener = function (listener) {
            this.listeners.push(listener);
        };
        /**
         * Remove listener from the action
         * @param listener Listener to remove
         */
        Action.prototype.removeListener = function (listener) {
            var index = this.listeners.indexOf(listener);
            if (index >= 0) {
                this.listeners.splice(index, 1);
            }
        };
        /**
         * A mutex to ensure that only one action is executing at any time.
         * This prevents cascading actions.
         */
        Action.executing = false;
        return Action;
    }());
    exports.Action = Action;
});
